import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AdminDashboard from '../pages/AdminDashboard';
import AdminDrivers from '../pages/admin/AdminDrivers';
import AdminJobs from '../pages/admin/AdminJobs';
import AdminScheduledJobs from '../pages/admin/AdminScheduledJobs';
import AdminEarnings from '../pages/admin/AdminEarnings';
import AdminCustomers from '../pages/admin/AdminCustomers';
import AdminSupport from '../pages/admin/AdminSupport';
import AdminAnalytics from '../pages/admin/AdminAnalytics';
import AdminNotifications from '../pages/admin/AdminNotifications';
import AdminSettings from '../pages/admin/AdminSettings';
import AdminPredefinedJobs from '../pages/admin/AdminPredefinedJobs';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import TermsOfService from '../pages/TermsOfService';
import AdminLayout from '../components/admin/AdminLayout';
import PrivateRoute from '../components/PrivateRoute';

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<PrivateRoute element={() => <AdminLayout><AdminDashboard /></AdminLayout>} />} />
      <Route path="/dashboard" element={<PrivateRoute element={() => <AdminLayout><AdminDashboard /></AdminLayout>} />} />
      <Route path="/drivers" element={<PrivateRoute element={() => <AdminLayout><AdminDrivers /></AdminLayout>} />} />
      <Route path="/jobs" element={<PrivateRoute element={() => <AdminLayout><AdminJobs /></AdminLayout>} />} />
      <Route path="/predefined-jobs" element={<PrivateRoute element={() => <AdminLayout><AdminPredefinedJobs /></AdminLayout>} />} />
      <Route path="/scheduled-jobs" element={<PrivateRoute element={() => <AdminLayout><AdminScheduledJobs /></AdminLayout>} />} />
      <Route path="/earnings" element={<PrivateRoute element={() => <AdminLayout><AdminEarnings /></AdminLayout>} />} />
      <Route path="/customers" element={<PrivateRoute element={() => <AdminLayout><AdminCustomers /></AdminLayout>} />} />
      <Route path="/support" element={<PrivateRoute element={() => <AdminLayout><AdminSupport /></AdminLayout>} />} />
      <Route path="/analytics" element={<PrivateRoute element={() => <AdminLayout><AdminAnalytics /></AdminLayout>} />} />
      <Route path="/notifications" element={<PrivateRoute element={() => <AdminLayout><AdminNotifications /></AdminLayout>} />} />
      <Route path="/settings" element={<PrivateRoute element={() => <AdminLayout><AdminSettings /></AdminLayout>} />} />
      <Route path="/tracking" element={<PrivateRoute element={() => <AdminLayout><div>Live Tracking Page</div></AdminLayout>} />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
    </Routes>
  );
};

export default AdminRoutes; 